import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

import { applySEO, canonicalPath, isPublicPath } from "./seo";

export default function SEOHead() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    const blog = canonicalPath(pathname).startsWith("/blog");
    applySEO({
      pathname,
      title: blog ? "Blog Profimy | Guides pour l'achat-revente et le sourcing" : "Profimy Margin | Comparateur de prix et calcul de marges",
      description: blog ? "Guides Profimy sur le sourcing, la comparaison des prix et le calcul des marges pour vendre sur les marketplaces." : "Comparez les prix entre marketplaces, calculez vos marges et suivez les opportunités d'achat-revente avec Profimy Margin.",
      indexable: isPublicPath(pathname),
    });
  }, [pathname]);
  return null;
}
